/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import {
  bool, func, string, node,
} from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import './Switch.scss';

export default class Switch extends Component {
  static propTypes = {
    selected: bool,
    disabled: bool,
    onChange: func,
    children: node,
    id: string,
    booleanValuesOnly: bool,
    type: string,
  };

  static defaultProps = {
    selected: false,
    disabled: false,
    onChange: null,
    id: '',
    children: '',
    booleanValuesOnly: false,
    type: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      selected: props.selected,
    };

    this.onClick = this.onClick.bind(this);
    this.uniqueId = props.id || _.uniqueId('switch-');
  }

  componentDidUpdate(prevProps, prevState) {
    const { onChange, booleanValuesOnly } = this.props;
    const { selected } = this.state;

    if (prevState.selected !== selected && onChange && !booleanValuesOnly) {
      onChange(this.uniqueId, selected);
    }
  }

  onClick() {
    const { disabled } = this.props;
    if (!disabled) {
      this.toggle();
    }
  }

  toggle() {
    const { onChange, booleanValuesOnly } = this.props;
    if (onChange && booleanValuesOnly) {
      this.setState(prevState => ({
        selected: !prevState.selected,
      }),
      () => {
        const { selected } = this.state;
        onChange(selected);
      });
      return;
    }
    this.setState(prevState => ({
      selected: !prevState.selected,
    }));
  }

  render() {
    const { selected } = this.state;
    const { children, disabled, type } = this.props;
    const classes = [
      'switch',
      {
        'switch-selected': selected,
        'switch-disabled': disabled,
      },
    ];
    const switchInput = (
      <input
        onClick={e => e.stopPropagation()}
        id={this.uniqueId}
        type="checkbox"
        value={selected}
        defaultChecked={selected}
        disabled={disabled}
        data-selector-selected={selected}
        data-selector-disabled={disabled}
        data-selector-type="switch-state"
      />
    );

    switch (type) {
      case 'applicationFormSwitch':
        return (
          <label
            htmlFor={this.uniqueId}
            className={classNames(
              'switch-container',
              'switch-container-reversed',
              {
                'switch-unselected-spacing': !selected,
              }
            )}
            data-selector={this.uniqueId}
            data-selector-type="switch"
          >
            {children}
            <span className={classNames(classes)} onClick={this.onClick} data-selector-type="switch-checkbox" />
          </label>
        );
      default:
        return (
          <label htmlFor={this.uniqueId} className="switch-container" data-selector={this.uniqueId} data-selector-type="switch">
            <span className={classNames(classes)} onClick={this.onClick} data-selector-type="switch-checkbox" />
            {switchInput}
            {children}
          </label>
        );
    }
  }
}
